import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useLanguage } from '../../context/LanguageContext';

function TraderSidebar({
  validTraders,
  selectedTrader,
  setSelectedTrader,
  getTraderQuestStats,
  TRADER_COLORS,
  TRADER_FALLBACK_IMAGES
}) {
  const { t } = useLanguage();

  return (
    <div className="col-span-12 lg:col-span-3">
      <div className="bg-[#09090b] border border-white/5 rounded-sm p-4 sticky top-24 shadow-xl">
        <h3 className="text-zinc-500 text-[10px] font-black uppercase tracking-widest mb-4 flex items-center gap-2">
          {t('traders') || 'Traders'}
        </h3>
        <div className="space-y-1">
          <button
            onClick={() => setSelectedTrader('all')}
            className={`w-full text-left px-3 py-2.5 rounded-sm transition-all duration-200 border ${selectedTrader === 'all' ? 'bg-emerald-900/20 border-emerald-500/50 text-white' : 'border-transparent text-zinc-400 hover:bg-zinc-900 hover:text-white'}`}
          >
            <div className="font-bold text-sm uppercase tracking-wide">{t('all_traders') || 'All Traders'}</div>
            <div className="text-[10px] opacity-60 font-mono">OVERVIEW</div>
          </button>

          {validTraders.map(trader => {
            const stats = getTraderQuestStats(trader.id);
            const percent = stats.total > 0 ? Math.round((stats.completed / stats.total) * 100) : 0;
            const tColor = TRADER_COLORS[trader.normalizedName] || '#71717a';

            return (
              <button
                key={trader.id}
                onClick={() => setSelectedTrader(trader.id)}
                className={`group w-full text-left px-3 py-2 rounded-sm transition-all duration-200 border flex items-center gap-3 ${selectedTrader === trader.id ? 'text-white' : 'border-transparent text-zinc-400 hover:bg-zinc-900 hover:text-white'}`}
                style={selectedTrader === trader.id ? { borderColor: tColor, backgroundColor: `${tColor}15` } : {}}
              >
                <LazyLoadImage
                  src={trader.imageLink || TRADER_FALLBACK_IMAGES[trader.normalizedName] || TRADER_FALLBACK_IMAGES['default']}
                  alt={trader.name}
                  effect="blur"
                  className="w-8 h-8 rounded-sm object-cover border border-zinc-700 group-hover:border-zinc-500 transition-colors grayscale group-hover:grayscale-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-xs uppercase tracking-wide truncate" style={{ color: selectedTrader === trader.id ? tColor : undefined }}>
                    {t(`trader_${trader.normalizedName}`) || trader.name}
                  </div>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex-1 h-1 bg-zinc-800 rounded-full overflow-hidden">
                      <div className="h-full rounded-full transition-all" style={{ width: `${percent}%`, backgroundColor: tColor }}></div>
                    </div>
                    <div className="text-[9px] opacity-60 font-mono">{percent}%</div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default TraderSidebar;